// src/app/dvm-tool/dvm-tool-routing.module.ts
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CustomRoutes } from '../shared/models/Routing'
import { ApplicationArea } from '../shared/services/ppv.api'
import { DVMToolLandingComponent } from './dvm-tool-landing/dvm-tool-landing.component'
import { DVMToolDashboardComponent } from './dvm-tool-dashboard/dvm-tool-dashboard.component'
import { DVMToolTeamDashboardComponent } from './dvm-tool-team-dashboard/dvm-tool-team-dashboard.component'
import { DVMToolPlanComponent } from './dvm-tool-plan/dvm-tool-plan.component'
import { ReportingDashboardComponent } from './reporting-dashboard/reporting-dashboard.component'
import { PeerInputPageComponent } from './dvm-tool-plan/peer-input-page/peer-input-page.component'
import { BreadcrumbResolver, ReviewsBreadcrumbResolver, ReviewsBreadcrumbQueryParamsResolver, AdminBreadcrumbResolver } from './breadcrumb.resolver'

const routes: CustomRoutes = [
   {
      path: '',
      component: DVMToolLandingComponent,
      data: { breadcrumb: 'Home' },
   },
   {
      path: 'reviews',
      runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      data: {
         areaName: 'Performance Hub',
         requiredRole: { application: ApplicationArea.DVMTool },
      },
      resolve: {
         breadcrumb: ReviewsBreadcrumbResolver,
         breadcrumbQueryParams: ReviewsBreadcrumbQueryParamsResolver,
      },
      children: [
         {
            path: '',
            component: DVMToolDashboardComponent,
            data: { breadcrumb: 'Home' },
         },
         {
            path: ':revieweeId',
            component: DVMToolPlanComponent,
            resolve: { breadcrumb: BreadcrumbResolver },
         },
      ],
   },
   {
      path: 'team-reviews',
      runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      data: {
         areaName: 'Performance Hub',
         requiredRole: { application: ApplicationArea.DVMTool },
      },
      resolve: {
         breadcrumb: ReviewsBreadcrumbResolver,
         breadcrumbQueryParams: ReviewsBreadcrumbQueryParamsResolver,
      },
      children: [
         {
            path: '',
            component: DVMToolTeamDashboardComponent,
            data: { breadcrumb: 'Home' },
         },
         {
            path: ':revieweeId',
            component: DVMToolPlanComponent,
            resolve: { breadcrumb: BreadcrumbResolver },
         },
      ],
   },
   {
      path: 'admin',
      data: { breadcrumb: 'Admin' },
      children: [
         {
            path: '',
            component: ReportingDashboardComponent,
            data: { breadcrumb: '' },
         },
         {
            path: ':section',
            component: ReportingDashboardComponent,
            resolve: { breadcrumb: AdminBreadcrumbResolver },
         },
      ],
   },
   { 
	  path: 'peer-input/:id',
      data: { breadcrumb: 'Home' },
	  component: PeerInputPageComponent
   },
]

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule],
})
export class DvmToolRoutingModule {}
